module.exports = __webpack_public_path__ + "img/omm_logo.e69a8ce4.png";